import { render } from "./SystemIntegrationDashboard.vue?vue&type=template&id=41fd498b&scoped=true"
import script from "./SystemIntegrationDashboard.vue?vue&type=script&lang=js"
export * from "./SystemIntegrationDashboard.vue?vue&type=script&lang=js"

import "./SystemIntegrationDashboard.vue?vue&type=style&index=0&id=41fd498b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fd498b"]])

export default __exports__